<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("seuPlano") }}
        </h1>
      </div>
    </div>
    <AssinarForm />
  </div>
</template>

<script>
import AssinarForm from './components/AssinarForm.vue';

export default {
  components: { AssinarForm },
};
</script>
